import { useTranslation } from 'next-i18next';
import React from 'react';

import { ExternalButtonLink } from '../ui/buttons';
import Icon from '../ui/Icon';
import { Content } from '../ui/layout';

export type AtlasHeaderProps = {
  className?: string;
};

const AtlasHeader: React.FC<AtlasHeaderProps> = () => {
  const { t } = useTranslation();
  return (
    <div className='w-full bg-white shadow-floating'>
      <div className='h-16'>
        <Content
          centered
          type='header'
          className='flex h-full items-center justify-between'
        >
          <Icon
            name='icon-atlas-world'
            className='h-6 w-6 text-transparent webS:hidden'
          />
          <Icon
            name='icon-atlas-logo'
            className='hidden h-8 w-[160px] text-transparent webS:!block'
          />
          <nav>
            <ul className='flex h-full'>
              <li>
                <ExternalButtonLink
                  href='https://www.atlasmetrics.io'
                  variant='secondary-outline'
                >
                  {t('atlas-metrics.visit')}
                </ExternalButtonLink>
              </li>
            </ul>
          </nav>
        </Content>
      </div>
    </div>
  );
};

export default AtlasHeader;
